import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, History } from "lucide-react";
import { getFavorites, getRecents, PREFS_EVENT } from "@/lib/favorites";
import { getTool } from "@/lib/toolsData";

const Row = ({ title, icon: Icon, slugs, testid }) => {
  const items = slugs.map(getTool).filter(Boolean);
  if (items.length === 0) return null;
  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4 text-primary" />
        <p className="overline text-muted-foreground">{title}</p>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {items.map((t) => {
          const Ti = t.icon;
          return (
            <Link
              key={t.slug}
              to={`/tool/${t.slug}`}
              data-testid={`quick-${t.slug}`}
              className="flex items-center gap-2 border border-border bg-card px-3 py-2 text-sm font-medium transition-transform duration-200 hover:-translate-y-0.5 hover:hard-shadow"
            >
              <Ti className="h-4 w-4 text-primary" /> {t.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export const FavoritesBar = () => {
  const [favs, setFavs] = useState(getFavorites());
  const [recents, setRecents] = useState(getRecents());

  useEffect(() => {
    const update = () => { setFavs(getFavorites()); setRecents(getRecents()); };
    window.addEventListener(PREFS_EVENT, update);
    window.addEventListener("focus", update);
    return () => { window.removeEventListener(PREFS_EVENT, update); window.removeEventListener("focus", update); };
  }, []);

  if (favs.length === 0 && recents.length === 0) return null;

  return (
    <section className="border-b border-border bg-card">
      <div className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-8">
        <Row title="Your Favorites" icon={Star} slugs={favs} testid="favorites-row" />
        <Row title="Recently Used" icon={History} slugs={recents} testid="recents-row" />
      </div>
    </section>
  );
};
